/**
 * Default apk-service download endpoint per `NEXT_PUBLIC_APP_ENV` (AC-902). The
 * hosts are fixed by the infrastructure (AC-901), so they live here instead of
 * in every deployment's env; `NEXT_PUBLIC_APK_DOWNLOAD_URL` still overrides.
 * `local` uses dev: there is no local apk-service.
 */
export const APK_DOWNLOAD_URLS: Record<string, string> = {
    local: "https://apk.alddev.xyz/public/apk/download",
    dev: "https://apk.alddev.xyz/public/apk/download",
    prod: "https://apk.playwebservice.com/public/apk/download",
};
